module.exports = __webpack_public_path__ + "static/media/person.361cfe96.svg";